export default __webpack_public_path__ + "28e85808b985bce5b1e85b158e343e9a.png";